module.exports = __webpack_public_path__ + "static/media/6.fdf6f328.png";